import classNames from 'classnames';
import { Link } from '@/components/Link';
import { Button, getButtonClassName } from '@/components/Button';

export type MessageBoxButtonProps = {
  primary?: boolean;
  bare?: boolean;
  disabled?: boolean;
  caption: string;
  url?: string;
  autoClose?: boolean;
  onClick?: () => void;
};

function getMessageBoxButtonVariant(props: MessageBoxButtonProps) {
  return props.primary ? 'primary' : props.bare ? 'bare' : 'secondary';
}

function MessageBoxButton(props: MessageBoxButtonProps) {
  return (
    <Button
      autoFocus={props.primary}
      variant={getMessageBoxButtonVariant(props)}
      disabled={props.disabled}
      className={classNames('uppercase ', props.bare && '!text-primary !py-0')}
      onClick={props.onClick}
    >
      {props.caption}
    </Button>
  );
}

function MessageBoxLink(props: MessageBoxButtonProps) {
  return (
    <Link
      className={getButtonClassName(getMessageBoxButtonVariant(props), 'text-center uppercase')}
      href={props.url!}
      onClick={props.onClick}
      noExternalIcon
    >
      {props.caption}
    </Link>
  );
}

type MessageBoxButtonsProps = {
  buttons?: MessageBoxButtonProps[];
  onClick?: (button: MessageBoxButtonProps) => void;
};

const defaultButtons: MessageBoxButtonProps[] = [{ primary: true, caption: 'OK' }];

export function MessageBoxButtons(props: MessageBoxButtonsProps) {
  const buttons = props.buttons || (defaultButtons as MessageBoxButtonProps[]);
  function buttonClicked(button: MessageBoxButtonProps) {
    button.onClick?.();
    props.onClick?.(button);
  }
  return (
    <div className="flex flex-col mt-8 gap-5">
      {buttons?.map((button, index) =>
        Object.prototype.hasOwnProperty.call(button, 'url') ? (
          button.url ? (
            <MessageBoxLink key={index} {...button} onClick={() => buttonClicked(button)} />
          ) : (
            <MessageBoxButton key={index} {...button} disabled={true} />
          )
        ) : (
          <MessageBoxButton key={index} {...button} onClick={() => buttonClicked(button)} />
        ),
      )}
    </div>
  );
}
